var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRetryArtwork = function SvgIconRetryArtwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.5 4.398a9.27 9.27 0 0 0-2.675.399.75.75 0 1 1-.43-1.437c.93-.278 1.963-.462 3.105-.462a9.418 9.418 0 0 1 9.42 9.42 9.418 9.418 0 0 1-9.42 9.42 9.418 9.418 0 0 1-9.42-9.42 9.42 9.42 0 0 1 1.586-5.236.75.75 0 0 1 1.248.832 7.92 7.92 0 0 0-1.334 4.404 7.918 7.918 0 0 0 7.92 7.92 7.918 7.918 0 0 0 7.92-7.92 7.918 7.918 0 0 0-7.92-7.92Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M8.753.434a.75.75 0 0 1 .073 1.058l-2.89 3.32a.75.75 0 0 1-1.132-.984l2.89-3.32A.75.75 0 0 1 8.753.434Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M4.764 3.878a.75.75 0 0 1 1.048-.163l3.37 2.46a.75.75 0 0 1-.884 1.211l-3.37-2.46a.75.75 0 0 1-.164-1.048Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconRetryArtwork;